import { render, staticRenderFns } from "./r-boat-page.vue?vue&type=template&id=44bd3dfa"
import script from "./r-boat-page.vue?vue&type=script&lang=js"
export * from "./r-boat-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bd3dfa')) {
      api.createRecord('44bd3dfa', component.options)
    } else {
      api.reload('44bd3dfa', component.options)
    }
    module.hot.accept("./r-boat-page.vue?vue&type=template&id=44bd3dfa", function () {
      api.rerender('44bd3dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-page.vue"
export default component.exports